import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const HeroSection = () => {
  const navigate = useNavigate();
  
  const handleStartAssessment = () => {
    // Navigate to the assessment page
    navigate("/assessment");
  };
  
  return (
    <section className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 relative overflow-hidden bg-white">
      <div className="container max-w-4xl mx-auto text-center relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="mb-8 sm:mb-10 md:mb-16 flex justify-center">
          <img 
            src="/lovable-uploads/09f539e7-7152-48ef-9cdc-06aeebe1948b.png"
            alt="AIMAA Logo"
            width="384"
            height="96"
            className="h-24 w-auto"
          />
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[72px] font-bold leading-tight tracking-tight mb-4 sm:mb-6 md:mb-8 text-[#0f2d69]">
          AI Maturity<br />Assessment<br />and Alignment
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-600 mb-6 sm:mb-8 md:mb-12 max-w-3xl mx-auto px-0 sm:px-4 leading-relaxed">
          A research-based methodology for evaluating and enhancing organizational AI capabilities
        </p>
        
        <div className="px-0 sm:px-4">
          <Button 
            onClick={handleStartAssessment}
            className="w-full sm:w-auto h-12 px-8 text-base bg-[#0f2d69] hover:bg-[#0f2d69]/90 rounded-md shadow-lg"
          >
            <span className="relative z-10 flex items-center justify-center gap-2">
              Start Assessment
              <ArrowRight className="ml-2 h-5 w-5" />
            </span>
          </Button>
        </div>

        <p className="text-xs sm:text-sm text-gray-500 mt-6 sm:mt-8 px-4">
          If you have any suggestions, please write to{' '}
          <a 
            href="mailto:info@aimaa.org"
            className="text-[#0f2d69]"
          >
            info@aimaa.org
          </a>
        </p>
      </div>
    </section>
  );
};
